// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `::ng-deep .mat-button:hover .mat-button-focus-overlay {
   opacity: 0.04 !important;
}

input {
   height: 32px;
   padding-right: 36px;
   width: 100%;
}

.pwd-hint {
   margin-top: 5px;
   margin-bottom: 1em;
}

mat-icon {
   width: 32px;
   height: 32px;
   line-height: 32px;
   padding: 4px;
   text-align: center;
   position: absolute;
   right: 0;
   margin-top: 5px;
   top: 0;
   bottom: auto;
}

.error {
   font-size: 12px;
   color: #d32f2f;
}
`, "",{"version":3,"sources":["webpack://./src/app/e-signature/setpassword-dialog/setpassword-dialog.component.css"],"names":[],"mappings":"AAAA;GACG,wBAAwB;AAC3B;;AAEA;GACG,YAAY;GACZ,mBAAmB;GACnB,WAAW;AACd;;AAEA;GACG,eAAe;GACf,kBAAkB;AACrB;;AAEA;GACG,WAAW;GACX,YAAY;GACZ,iBAAiB;GACjB,YAAY;GACZ,kBAAkB;GAClB,kBAAkB;GAClB,QAAQ;GACR,eAAe;GACf,MAAM;GACN,YAAY;AACf;;AAEA;GACG,eAAe;GACf,cAAc;AACjB","sourcesContent":["::ng-deep .mat-button:hover .mat-button-focus-overlay {\n   opacity: 0.04 !important;\n}\n\ninput {\n   height: 32px;\n   padding-right: 36px;\n   width: 100%;\n}\n\n.pwd-hint {\n   margin-top: 5px;\n   margin-bottom: 1em;\n}\n\nmat-icon {\n   width: 32px;\n   height: 32px;\n   line-height: 32px;\n   padding: 4px;\n   text-align: center;\n   position: absolute;\n   right: 0;\n   margin-top: 5px;\n   top: 0;\n   bottom: auto;\n}\n\n.error {\n   font-size: 12px;\n   color: #d32f2f;\n}\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
